module.exports = __webpack_public_path__ + "static/media/timer.5997327a.svg";